import { Criteria } from '../../../data/criteria';
import { DynamicContainerComponent } from '../../dynamic-component-injector/dynamic-container/dynamic-container.component';
import {
    Component,
    Inject,
    Input,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Catalog } from 'idk/data/catalog';
import { ComponentType } from '@angular/cdk/overlay';
import { IBusinessObject } from 'idk/abstractions/business-object';
import { MultiModeComponent } from 'idk/widgets/components/multi-mode.component';
import { ComponentDescriptor } from 'idk/widgets/dynamic-component-injector/component-descriptor';

@Component({
    selector: 'app-finder-container',
    templateUrl: './finder-container.component.html',
    standalone: false,
})
export class FinderContainerComponent<
    TComponent extends MultiModeComponent<TCatalog, TEntity, TKey, TCriteria>,
    TCatalog extends Catalog<TEntity, TKey, TCriteria>,
    TEntity extends IBusinessObject<TKey>,
    TKey,
    TCriteria extends Criteria
> implements OnInit
{
    @ViewChild('dcList')
    public dcList: DynamicContainerComponent;

    private get componentInstance(): MultiModeComponent<
        TCatalog,
        TEntity,
        TKey,
        TCriteria
    > {
        return this.dcList.component as any as MultiModeComponent<
            TCatalog,
            TEntity,
            TKey,
            TCriteria
        >;
    }

    @Input()
    public component: ComponentType<TComponent>;

    public descriptor: ComponentDescriptor<any, any>;

    public constructor(
        protected _dialog: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA)
        public dialogData: { selected: TEntity[]; multiSelect: boolean }
    ) {}

    public ngOnInit(): void {
        this.descriptor = {
            component: this.component,
            context: null,
        };
    }

    public onSelectItems(): void {
        this._dialog.close(this.componentInstance.selectedItems);
    }

    public onClose(): void {
        this._dialog.close();
    }

    public onUserSelected(user: TEntity): void {
        this._dialog.close(user);
    }
}
